import logo from './logo.svg';
import './App.css';
import React from "react";

function Opcion(props){
  let total_tab= (props.tabs-1) * 50 + 10
  return(
    <div className='opcion' style={{marginLeft: total_tab}}>
    {props.id}
      <input
        className = 'tipo'
          onInput={(e) => {
            props.fun(props.id,e.target.value);
          }}
      />
      <button onClick={()=>props.addQuest(props.id)}>Derivar pregunta</button>
    </div>
  )
}

function Pregunta(props){
  const [tipo, changeTipoInterno] = React.useState("text");
  let total_tab= (props.tabs-1) * 50 + 10
  return(
    <div>
    <div className="pregunta" style={{marginLeft: total_tab}}>
    Pregunta
    <br/>
    <h6>{props.id}</h6>
    <br/>
      <input
          onInput={(e) => {
            props.fun(props.id,e.target.value);
          }}
      />
      <br/>
      <select
        onChange={(e)=>{
          props.changeTipo(props.id,e.target.value)
          changeTipoInterno(e.target.value)
        }}>
        <option value="text">Abierta</option>
        <option value="opciones">Opciones</option>
      </select>
      {tipo === 'opciones' ? (
        <button onClick={()=>props.addOption(props.id)}>
          Agregar opción
        </button>
      ): ""
      }
    </div>
    </div>
  )
}

function Encuesta(props){
  //const [input, changeInput] = React.useState({});
  const [questSize, changeQuestSize] = React.useState(1);
  const [arbol, changeArbol] = React.useState({survey:{}})
  const [update, changeUpdate] = React.useState(true);

  const addOption2element = (id) => {
    let elemento = {
      enunciado: '',
    }
    let neo_arbol = arbol
    let nodo = dondeColocoEsteId(id, neo_arbol)
    //nodo = neo_arbol
    if(!nodo.hasOwnProperty('opciones')){
      nodo.opciones = {}
    }
    let claves = id.split('.')
    id = claves[claves.length-1]
    nodo.opciones[id] = elemento
    //changeArbol(neo_arbol)

  }

  //regresa el nodo donde un id debe ser insertado
  // un posible nombre podria ser dondeColocoEsteId
  const dondeColocoEsteId = (id, nodo) => {
    let claves = id.split('.')
    //ir hasta el nodo donde se debe colocar el id
    for(let i = 0; i < claves.length - 1; i++ ){
      let clave = claves[i]
      if(clave[0] !== 'o'){
        nodo = nodo.survey[clave]
      }
      else{
        nodo = nodo.opciones[clave]
      }
    }
    return nodo
  }

  const addElement2survey = (id) => {
    let elemento = {
      enunciado: '',
      tipo: 'text',
    }

    let nodo = dondeColocoEsteId(id,arbol)
    if(!nodo.hasOwnProperty('survey')){
      nodo.survey = {}
    }
    let claves = id.split('.')
    id = claves[claves.length-1]
    nodo.survey[id] = elemento

  }


  const getNodo = (id) => {
    let nodo = arbol
    let claves = id.split('.')
    //ir hasta el nodo correcto
    for(let i = 0; i < claves.length; i++ ){
      let clave = claves[i]
      if(clave[0] !== 'o'){
        nodo = nodo.survey[clave]
      }
      else{
        nodo = nodo.opciones[clave]
      }
    }
    return nodo
  }

  const changeInput = (id,texto) => {
    let node = getNodo(id,arbol)
    node.enunciado = texto
    console.log(arbol)
    console.log(mostrar)
  }

  const changeTipo = (id,tipo) => {
    let nodo = getNodo(id,arbol)
    nodo.tipo = tipo
    if (tipo === 'opciones') {
      if(!nodo.hasOwnProperty('opciones')){
        addOption2element(String(id)+'.o1')
      }
      //añadir una opcion
      //revisar cuantas opciones hay en el dict de opciones para determinar el siguiente id,
    }
    changeUpdate(!update)
  }

  const addDeepQuest = (id) => {
    let nodo = getNodo(id,arbol)
    if(!nodo.hasOwnProperty('survey')){
      addElement2survey(id+'.1')
    }
    else{
      let size = Object.keys(nodo.survey).length + 1;
      addElement2survey(id+'.'+size.toString())
    }
    changeUpdate(!update)
  }

  const addOption = (id) => {
    let nodo = getNodo(id,arbol)
    let size = Object.keys(nodo.opciones).length + 1;
    addOption2element(id+'.o'+size.toString())
    changeUpdate(!update)
  }


  let mostrar = []
  const desplegar = (arbol) => {
    let stack = []
    for(let element in arbol.survey){
      stack.unshift({clase:'pregunta', id:element, body: arbol.survey[element]})
    }

    while(stack.length > 0){
      let item = stack.pop()
      let tabs = item.id.split('.').length
      if (item.clase === 'pregunta'){
        mostrar.push(
          <Pregunta
          tabs={tabs}
          key={item.id}
          id={item.id}
          fun={changeInput}
          changeTipo={changeTipo}
          addOption={addOption}/>
        )

        if(item.body.tipo === 'opciones'){
          let temp = []
          for(let opt in item.body.opciones){
            temp.unshift({clase:'opcion', id: item.id +'.'+ opt, body: item.body.opciones[opt]})
          }
          for(let element of temp){
            stack.push(element)
          }
        }
      }
      else{
        mostrar.push(
          <Opcion
          tabs={tabs}
          key={item.id}
          id={item.id}
          fun={changeInput}
          addQuest={addDeepQuest}/>
        )
        if(item.body.hasOwnProperty('survey')){
          mostrar.push(
            <div className='sub'></div>
          )
          let temp = []
          for(let element in item.body.survey){
            temp.unshift({clase:'pregunta', id:item.id +'.'+ element, body: item.body.survey[element]})
          }
          for(let element of temp){
            stack.push(element)
          }
        }

      }
    }
  }
  desplegar(arbol)


  const addQuest = () => {
    changeQuestSize(questSize + 1)
    addElement2survey(questSize.toString())
  }

  const publicar = () => {
    fetch('https://halbot21.herokuapp.com/upload_survey', {
      method: 'POST', // or 'PUT'
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(arbol),
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }



  return(
    <>
      <h1>Ecuesta</h1>
      {mostrar}
      <div className= 'encuesta'>
      </div>
      <button className= 'encuesta-but' onClick={() => addQuest()}> Añade pregunta </button>
      {questSize>1?<button className= 'encuesta-but' onClick={() => publicar()}> Publicar encuesta </button>:""}
      <p></p>
    </>
  )
}

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <Encuesta />
      </header>
    </div>
  );
}

export default App;
